









import Vue from 'vue'
import Component from "vue-class-component"
import ProductsNavigation from "@/components/products/Navigation.vue"
import LayoutPublicProducts from "@/layouts/LayoutPublicProducts.vue"
import { Prop } from "vue-property-decorator"

@Component({
  components: {
    ProductsNavigation,
    LayoutPublicProducts
  }
})

export default class ProductsCategoriesView extends Vue {
  @Prop() publicUrl!: string

}
